import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SimpleCarousel from 'components/SimpleCarousel';
import ContentSimpleCard from 'components/Cards/ContentSimpleCard';
import NarrativeSmallCard from 'components/Cards/NarrativeSmallCard';
import { ContentWrapper } from './styles';

function Content(props) {
  const {
    literals, content, narratives,
  } = props;

  if (!content.length && !narratives.length) {
    return null;
  }

  return (
    <ContentWrapper>
      <div className='title_section'>
        <div className='number'>{content.length + narratives.length}</div>
        {literals.proposedContent}
      </div>
      <SimpleCarousel classesList='element_main_card' showButtons>
        {_.map(narratives, element => (
          <NarrativeSmallCard
            key={element.id}
            data={element}
            color={element.color}
            classesList='element_main_card'
          />
        ))}
        {_.map(content, element => (
          <ContentSimpleCard key={element.id} data={element} recognized classesList={['element_main_card']} />
        ))}
      </SimpleCarousel>
    </ContentWrapper>
  );
}

Content.propTypes = {
  content: PropTypes.array,
  narratives: PropTypes.array,
};

Content.defaultProps = {
  content: [],
  narratives: [],
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content/components/Content.jsx